export default __webpack_public_path__ + "static/media/img3.91d880e8.jpg";